import type { Listing } from './types';

import type { SearchResults } from '@/hooks/useSearch';

export const flattenAndSortSearchResults = (
  data: SearchResults,
  query: string
) =>
  data.reduce<Listing[]>(
    (acc, company) => [
      ...acc,
      ...[
        {
          id: company.objectID,
          label: company.name,
          name: company.name,
          website: company.website,
          uniqueSymbol: company.uniqueSymbol,
          tickerSymbol: company.tickerSymbol,
          exchangeCountryIso: company.exchangeCountryIso,
          tag: company.tag,
        },
        ...company.listings?.map((listing) => ({
          id: String(listing.tradingItemId),
          label: listing.uniqueSymbol,
          name: company.name,
          exchangeCountryIso: listing.exchangeCountryIso,
          listingCurrencyIso: listing.listingCurrencyIso,
          uniqueSymbol: listing.uniqueSymbol,
          website: company.website,
          tickerSymbol: listing.uniqueSymbol.split(':')?.[1],
          tag: null,
        })),
      ]
        .sort((a, b) => {
          // Sort by uniqueSymbol exact match first
          const isExactMatchA = a.uniqueSymbol === query;
          const isExactMatchB = b.uniqueSymbol === query;
          if (isExactMatchA && !isExactMatchB) return -1;
          if (!isExactMatchA && isExactMatchB) return 1;
          return 0;
        })
        .map((n, i) => ({
          // Primary listing is always first
          type: i === 0 ? ('primary' as const) : ('secondary' as const),
          ...n,
        })),
    ],
    []
  );
